import { RouteProp, useFocusEffect, useNavigation, useRoute } from "@react-navigation/native";
import { useAuth } from "../hooks/useAuth";
import BlankLayout from "../layouts/BlankLayout";
import Loader from "../components/common/status/Loader/Loader";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigation/AppNavigator.web";
import { useCallback } from "react";
import returnToUtils from "../utils/returnTo.utils";
import { useAppConfig } from "../AppConfigProvider";

function LoginSSOView() {
  const route = useRoute<RouteProp<RootStackParamList, "LoginSSO">>();
  const { login, isUpdating } = useAuth();
  const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();
  const appConfig = useAppConfig();

  useFocusEffect(
    useCallback(() => {
      const triggerLogin = async () => {
        if (route.params?.accessToken && route.params?.refreshToken) {
          await login(route.params.accessToken, route.params.refreshToken);

          const storedReturnToUrl = await returnToUtils.getAndClearReturnToUrl();

          let targetUrl: string | null = storedReturnToUrl;

          if (!targetUrl && route.params?.redirect && returnToUtils.isValidInternalUrl(route.params.redirect)) {
            targetUrl = route.params.redirect;
          }

          if (targetUrl) {
            window.location.href = targetUrl;
          } else {
            // Reload to root so AppNavigator can pick role-based initial route
            window.location.href = "/";
          }
        }
      };

      triggerLogin();
    }, [navigation, route, isUpdating, appConfig.isCompanionMode])
  );

  return (
    <BlankLayout>
      <Loader />
    </BlankLayout>
  );
}

export default LoginSSOView;
